import { keyframes, css } from 'styled-components';

const BigToSmallBounceAndFadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(1.2);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  60% {
    opacity: 1;
    transform: scale(1.2);
  }

  80% {
    opacity: 1;
    transform: scale(0.8);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const DiscountSuccessIconAnimation = css`
  opacity: 0;
  transform: scale(1.2);
  animation-name: ${BigToSmallBounceAndFadeIn};
  animation-duration: 0.8s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

const FadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const DiscountSuccessTitleAnimation = css`
  opacity: 0;
  animation-name: ${FadeIn};
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

export const DiscountSuccessContentAnimation = css`
  opacity: 0;
  animation-name: ${FadeIn};
  animation-delay: 0.4s;
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;
